/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ServiceAccountStatus {
    not_validated = 'not_validated',
    validated = 'validated',
    not_onboarded = 'not_onboarded',
    not_onboarded_validated = 'not_onboarded_validated',
    active = 'active',
    inactive = 'inactive',
    retired = 'retired',
    deleting = 'deleting'
}
